import merchStore from './js/widgets/merchStore.js';
import mainVideo from './js/widgets/mainVideo.js';
import hotButtons from './js/widgets/hotButtons.js';
import seoWidget from './js/widgets/seoWidget.js';
import ticketsCards from './js/widgets/ticketsCards.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import moreCards from './js/widgets/moreCards.js';
import sponsors from './js/widgets/sponsors.js';

import customFeatureLineUp from './js/featureLineUp.js';
import './js/localjs.js';

$(document).ready(function () {
  merchStore();
  if (window.location.pathname === '/') {
    mainVideo();
    hotButtons();
    seoWidget();
    ticketsCards();
    multiScheduleFeature();
    moreCards();
    sponsors();
  } else {
    customFeatureLineUp();
  }
});
